import * as React from "react"

type ContextProps = {
  host: HTMLElement | null
}

const initialContext: ContextProps = { host: null }
const LayerContext: React.Context<ContextProps> = React.createContext(
  initialContext
)

export default LayerContext
